import {
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
  Label,
  ResponsiveContainer,
} from "recharts";
import React, { useCallback, useState } from "react";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { useCurrentPng } from "recharts-to-png";
import FileSaver from "file-saver";
import { MasterOfActsAPI } from "../../api/api";
import { useSelector } from "react-redux";
import { getProfile } from "../../redux/reducers/user-profile-reducer";
import { Button } from "@material-ui/core";

function dataURLToBlob(dataURL) {
  const parts = dataURL.split(';base64,');
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
}


export const CustomLineChart = (initialValue, data, line, label, setFieldValue, variable, value) => {
  const createId = (id) => `chart-${id}`;

  const { user } = useSelector(getProfile);
  const [getPng, { ref, isLoading }] = useCurrentPng();
  const [activeIcon, setActiveIcon] = useState(false);

  const handleDownload = useCallback(async () => {
    const png = await getPng();
    if (png) {
      FileSaver.saveAs(png, `${label}.png`);
    }
  }, [getPng, label]);

  const handleSavePng = useCallback(async () => {
    const png = await getPng();
    if (png) {
      let imageBlob = dataURLToBlob(png);
      const response = await MasterOfActsAPI.uploadChart(imageBlob, user.id)
      if (response) {
        setFieldValue(variable,
          {
            ...value,
            id: response.data.id
          }
        )
      }
    }
  }, [getPng, user.id]);



  const handleOver = useCallback((e) => {
    e.stopPropagation();
    setActiveIcon(true);
  }, []);
  const handleOut = useCallback((e) => {
    e.stopPropagation();
    setActiveIcon(false);
  },[]);
  
  return (
    <React.Fragment>
      {line.length === 0 ? (
        <div style={{ height: "580px" }}>
          <h1>Добавьте данные</h1>
        </div>
      ) : (
        <React.Fragment>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <InsertDriveFileIcon
          onMouseOver={handleOver}
          onMouseOut={handleOut}
          style={{width: '36px', height: '36px', color: activeIcon ? 'red' : 'black'}}
          onClick={handleDownload}
          />
          <Button 
            onClick={handleSavePng}
            color="primary"
            variant="outlined"
            >
            Сохранить график
          </Button>
        </div>
        <ResponsiveContainer width={'100%'}  height={560}>
          <LineChart
            width={750}
            height={600}
            data={data}
            margin={{ top: 15, right: 30, left: 20, bottom: 20 }}
            ref={ref}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis reversed={initialValue.reverseOX} dataKey={"name"}>
              <Label value={initialValue.OX} offset={0} position="bottom" />
            </XAxis>
            <YAxis reversed={initialValue.reverseOY}>
              <Label
                value={initialValue.OY}
                angle={"-90"}
                position="left"
                textAnchor="middle"
              />
            </YAxis>
            <Tooltip />
            {initialValue.legend !== "none" && (
              <Legend align="center" verticalAlign="top" height={36} />
            )}
            {line.map((ln, index) => (
              <Line
                key={createId(index)}
                type={ln.type}
                dataKey={ln.dataKey}
                stroke={ln.stroke}
                legendType={initialValue.legendType}
                dot={initialValue.dot}
                isAnimationActive={initialValue.isAnimationActive}
                animationEasing={initialValue.animationEasing}
                activeDot={initialValue.activeDot ? { r: 6 } : false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </React.Fragment>
      )}
    </React.Fragment>
  );
};
